import React, { useEffect, useState } from 'react';
import { Flame } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { api } from './api';
import { usePlatform } from './PlatformContext';
import './streaks.css';

export const DailyStreakCard = ({ challengeId }) => {
  const { user, guest, day, scope, version } = usePlatform();
  const [snapshot, setSnapshot] = useState(null), [error, setError] = useState(''), [retry, setRetry] = useState(0);
  const key = `${user?.id}:${guest?.id}:${scope}:${day}:${challengeId}`;
  useEffect(() => {
    let alive = true;
    setSnapshot(null); setError('');
    api('/daily/summary').then(result => {
      if (!alive) return;
      if (result.user_id !== (user?.id || null) || (!user?.alias_confirmed && result.guest?.id !== guest?.id) || result.date !== day || result.scope !== scope || result.challenge_id !== challengeId || !result.streak?.completed_today) throw new Error('Your Daily streak could not be checked.');
      setSnapshot({ key, streak: result.streak });
    }).catch(() => { if (alive) setError('Your result is saved. Reconnect to check your Daily streak.'); });
    return () => { alive = false; };
  }, [key, user?.id, user?.alias_confirmed, guest?.id, day, scope, challengeId, version, retry]);
  if (error) return <div className="ps-identity streak-status" data-testid="daily-streak-error"><p>{error}</p><Button variant="ghost" data-testid="daily-streak-retry-button" onClick={() => setRetry(value => value + 1)}>Try again</Button></div>;
  if (snapshot?.key !== key) return <Skeleton className="streak-loading" data-testid="daily-streak-loading" aria-label="Checking your Daily streak"/>;
  const streak = snapshot.streak;
  return <Card className="ps-identity daily-streak-card" data-testid="daily-streak-card" aria-live="polite">
    {streak.new_best_today && <Badge variant="outline" className="daily-streak-record" data-testid="daily-streak-new-best-badge">NEW BEST DAILY STREAK</Badge>}
    <div className="daily-streak-card-title" data-testid="daily-streak-card-title"><Flame aria-hidden="true" size={19}/><strong data-testid="daily-streak-current-value">{streak.current}-day Daily streak</strong></div>
    <p data-testid="daily-streak-card-helper">Come back tomorrow to keep it going.</p>
    <small data-testid="daily-streak-best-value">Best Daily streak: {streak.best} {streak.best === 1 ? 'day' : 'days'}</small>
  </Card>;
};
